import React from 'react';

const SubscriptionPlanCard = ({ plan, onSelect }) => {
  // Format price from cents to dollars
  const formatPrice = (cents) => {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  };

  return (
    <div className="bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-shadow">
      <div className="p-6 flex flex-col h-full">
        <div className="flex-grow">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">{plan.name}</h3>
          <div className="mb-4">
            <span className="text-3xl font-bold">{formatPrice(plan.price_monthly)}</span>
            <span className="text-gray-500 ml-2">/month</span>
          </div>
          <p className="text-gray-600 mb-4">{plan.description}</p>
          <div className="mb-4">
            <p className="font-medium mb-2">Features:</p>
            <ul className="space-y-1">
              {plan.features.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 text-sm">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          <p className="text-sm text-gray-500 mb-4">
            {plan.max_users === null ? 'Unlimited users' : `Up to ${plan.max_users} users`}
          </p>
          {plan.price_yearly > 0 && (
            <p className="text-sm text-green-600 mb-4">
              Save {Math.round((1 - plan.price_yearly / (plan.price_monthly * 12)) * 100)}% with annual billing
            </p>
          )}
        </div>
        <button
          onClick={onSelect}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          {plan.price_monthly === 0 ? 'Current Plan' : 'Select Plan'}
        </button>
      </div>
    </div>
  );
};

export default SubscriptionPlanCard;